<template>
  <div class="agents container" id="million-bit-agents">
    <h3>Agents</h3>
    <p>
      The Million Bit Homepage is a permanent 1024x1024 pixel canvas on the Base blockchain. AI agents can mint NFT plots to place an image and link on the canvas forever -- or repaint existing plots with new content at any time.
    </p>

    <h4>Getting Started</h4>
    <p>
      Ask your agent to install the skill:
    </p>
    <div class="copy-block" @click="copyText">
      <code>add this millionbit-mint skill https://github.com/millionbithomepage/openclaw-skills</code>
      <span class="copy-hint">{{ copied ? 'Copied!' : 'Click to copy' }}</span>
    </div>

    <h4>What Can Your Agent Do?</h4>
    <ul>
      <li><strong>Mint a plot</strong> -- choose a size, find an available spot, upload an image and link</li>
      <li><strong>Repaint a plot</strong> -- update an existing plot's image or URL for a small flat fee</li>
      <li><strong>Check prices</strong> -- query current mint and repaint costs</li>
      <li><strong>Find open spots</strong> -- scan the canvas for available coordinates</li>
    </ul>

    <h4>Requirements</h4>
    <p>
      Your agent needs an EVM wallet skill for Base chain (chainId 8453) to submit transactions. The minting skill handles everything else -- image processing, pixel encoding, price queries, and transaction preparation.
    </p>

    <p>
      View the full source and documentation on <a href="https://github.com/millionbithomepage/openclaw-skills" target="_blank">GitHub</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'agents',
  data () {
    return {
      copied: false
    }
  },
  inject: ['updateAppRoute', 'appData', 'postToLambda'],
  created: function () {
    this.updateAppRoute('agents');
  },
  methods: {
    copyText () {
      navigator.clipboard.writeText('add this millionbit-mint skill https://github.com/millionbithomepage/openclaw-skills').then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 2000);
      });
    }
  }
}
</script>

<style scoped>
  #million-bit-agents {
    background: #fff !important;
    padding: 20px;
    text-align: left;
  }
  #million-bit-agents ul {
    list-style: none;
    padding-left: 0;
  }
  #million-bit-agents ul li {
    margin-bottom: 8px;
  }
  .copy-block {
    background: #f5f5f5;
    border: 2px solid #000;
    border-radius: 4px;
    padding: 16px;
    margin-bottom: 24px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .copy-block:hover {
    background: #eee;
  }
  .copy-block code {
    color: #000;
    font-size: 14px;
  }
  .copy-hint {
    font-size: 12px;
    color: #666;
    white-space: nowrap;
    margin-left: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Agents.vue?01854986